import {
  DraftJobWritingMode,
  GuidedDetailsType,
  type DraftJob,
} from 'src/graphql/generated';

export const isClassifyPageCompleted = (draftJob?: DraftJob) => {
  if (!draftJob) return false;
  if (
    draftJob.titles?.[0]?.title &&
    draftJob.locations?.[0]?.seekId &&
    draftJob.categories?.[0].categoryId &&
    draftJob.categories?.[0].subCategoryId &&
    draftJob.workTypes?.[0] &&
    draftJob.salary?.type &&
    draftJob.salary?.minimum &&
    draftJob.salary?.maximum &&
    // draftJob.salary?.isHidden &&
    draftJob.salary?.displayValue
  ) {
    return true;
  }
  return false;
};

export const isSelectAdPageCompleted = (draftJob?: DraftJob) =>
  Boolean(draftJob?.products?.productIds);

export const isWritePageCompleted = (draftJob?: DraftJob) =>
  draftJob?.jobWritingMode === DraftJobWritingMode.GUIDED
    ? (getQualifications(draftJob) ?? []).length !== 0 &&
      (getResponsibilities(draftJob) ?? []).length !== 0 &&
      Boolean(draftJob?.summary)
    : Boolean(draftJob?.details) && Boolean(draftJob?.summary);

export const isManagePageCompleted = (draftJob?: DraftJob) =>
  Boolean(draftJob?.questionnaireId);

const getQualifications = (draftJob?: DraftJob) =>
  draftJob?.guidedDetails?.filter(
    (job) => job?.type === GuidedDetailsType.QUALIFICATIONS,
  );

const getResponsibilities = (draftJob?: DraftJob) =>
  draftJob?.guidedDetails?.filter(
    (job) => job?.type === GuidedDetailsType.RESPONSIBILITIES,
  );
